import { render, staticRenderFns } from "./facility-error.vue?vue&type=template&id=c0a04872"
import script from "./facility-error.vue?vue&type=script&lang=js"
export * from "./facility-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports